import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';

@Component({
    selector: 'horizon-profile-toolbar',
    templateUrl: './horizon-profile-toolbar.component.html',
    styleUrls: ['./horizon-profile-toolbar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatToolbarModule, MatIconModule]
})
export class HorizonProfileToolbarComponent {
  @Output() logoutEvent = new EventEmitter();

  constructor() { }

  logout() {
    this.logoutEvent.emit();
  }
}
